module.exports = [{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-react-helmet-async@1.2.3_gatsby@5.16.0_babel-eslint@10.1.0_eslint@9.39.2__e70238d5768604bb17c630214f78f233/node_modules/gatsby-plugin-react-helmet-async/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.16.0_babel-eslint@10.1.0_eslint@9.39.2_jiti@1.21.7___react-dom@18.3.1_react@18_6bf4fa57e38f1397fe76bfef93be1a5e/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
